import { Button, Col, DatePicker, Divider, Form, Input, Row, Tooltip } from 'antd';
import { useMask } from 'App';
import React, { useEffect } from 'react'
import dayjs from "dayjs";
import { PlusCircleFilled } from "@ant-design/icons";
import API from 'API';

const NOW = dayjs();

export default function TermHandle({ terms, setTerms, selectedTerm, setSelecterdTerm, edit=true }) {
    const [form] = Form.useForm();
    const { setFullMask } = useMask();
    useEffect(() => {
        if (selectedTerm) {
            form.setFieldsValue(selectedTerm);
            return;
        }
        form.setFieldsValue({
            title: "",
            start_time: NOW.clone().startOf("day"),
            end_time: NOW.clone().add(90, "day").startOf("day")
        })
    }, [selectedTerm, form])
    return <>
        <div>
            {terms.length === 0 && <>Chưa có kỳ học nào</>}
            {terms.map(term => <div key={term.id} className={`term-div ${term.id === selectedTerm?.id ? "selected" : ""}`}
                onClick={() => setSelecterdTerm(term)}
            >
                {(term.title && term.title.trim()) || `${term.start_time.format("DD/MM/YYYY")} - ${term.end_time.format("DD/MM/YYYY")}`}
                {term.start_time.isBefore(NOW) && term.end_time.isAfter(NOW) && <> (Kỳ hiện tại)</>}
            </div>)}
            {edit && <Tooltip title="Tạo kỳ mới">
                <div className='term-div' onClick={() => {
                    setSelecterdTerm(null);
                }}>
                    <PlusCircleFilled />
                </div>
            </Tooltip>}
        </div>
        <Divider />
        {edit && <Form
            name="term"
            layout="vertical"
            form={form}
            onFinish={async (values) => {
                setFullMask(true);
                try {
                    var response;
                    const vals = {
                        ...values, start_time: values.start_time.format("YYYY-MM-DD"),
                        end_time: values.end_time.format("YYYY-MM-DD"),
                        start_week: values.start_week.format("YYYY-MM-DD"),
                        register_start_time: values.register_start_time && values.register_start_time.format("YYYY-MM-DD"),
                        register_end_time: values.register_start_time && values.register_end_time.format("YYYY-MM-DD"),
                    }
                    if (selectedTerm) {
                        response = await API.patch(`/terms/${selectedTerm.id}/`, vals);
                    } else {
                        response = await API.post("/terms/", vals);
                    }
                    response.data.start_time = dayjs(response.data.start_time);
                    response.data.end_time = dayjs(response.data.end_time);
                    response.data.start_week = dayjs(response.data.start_week);
                    response.data.register_start_time = values.register_start_time && dayjs(response.data.register_start_time);
                    response.data.register_end_time = values.register_start_time && dayjs(response.data.register_end_time);
                    if (selectedTerm) {
                        setTerms(terms => {
                            const index = terms.findIndex(item => item.id === selectedTerm.id);
                            terms[index] = response.data
                            return [...terms]
                        });
                    } else {
                        setTerms(terms => [...terms, response.data]);
                    }
                    setSelecterdTerm(response.data);
                } catch (e) {
                    console.log(e);
                } finally {
                    setFullMask(false);
                }
            }}
        >
            <Row gutter={8}>
                <Col span={7}>
                    <Form.Item
                        label="Tiêu đề"
                        name="title"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item
                        label="Bắt đầu kỳ"
                        name="start_time"
                        rules={[{ required: true }]}>
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item
                        label="Kết thúc kỳ"
                        name="end_time"
                        rules={[
                            { required: true },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    const start = getFieldValue('start_time');
                                    if (!value || !start || value.isAfter(start)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Ngày kết thúc phải sau ngày bắt đầu'));
                                },
                            }),
                        ]}>
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item
                        label=" "
                    >
                        <Button htmlType='submit' type="primary" style={{ width: "100%" }}>
                            {selectedTerm ? "Cập nhật" : "Tạo"}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={8}>
                <Col span={7}>
                    <Form.Item
                        label="Tuần bắt đầu học"
                        name="start_week"
                        rules={[
                            { required: true },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    const start = getFieldValue('start_time');
                                    if (!value || !start || value.isAfter(start)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Tuần bắt đầu học phải sau ngày bắt đầu'));
                                },
                            }),
                        ]}>
                        <DatePicker style={{ width: "100%" }}
                        onChange={(date) => {
                            if (date) {
                                const day = date.day();
                                const nextMonday = date.clone().add(1 - day, 'days').startOf('day');
                                form.setFieldsValue({
                                    start_week: nextMonday,
                                });
                            } else {
                                form.setFieldsValue({
                                    start_week: null,
                                });
                            }
                        }}
                        />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item
                        label="Bắt đầu đăng ký môn"
                        name="register_start_time"
                        // rules={[{ required: true }]}
                    >
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item
                        label="Kết thúc đăng ký môn"
                        name="register_end_time"
                        rules={[
                            // { required: true },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    const start = getFieldValue('register_start_time');
                                    if (!value || !start || value.isAfter(start)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Ngày kết thúc phải sau ngày bắt đầu'));
                                },
                            }),
                        ]}>
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>}
    </>
}